export enum RoleEnum {
  ADMIN = 1,
  CLIENT = 2,
  ACCOUNT_VIEWER = 3,
  VIEWER = 4,
  AGENCY = 5,
  DEVELOPER = 6,
  ACCOUNTANT = 7,
  MARKETER = 8,
  MARKETER_VIEW_ONLY = 9,
  RESTRICTED = 10,
}

export const isRestrictedUser = (role: number | undefined): boolean =>
  role === RoleEnum.RESTRICTED

export const isClientAdminUser = (role: number | undefined): boolean =>
  role === RoleEnum.CLIENT

export const isViewOnlyUser = (role: number | undefined): boolean =>
  role === RoleEnum.VIEWER || role === RoleEnum.MARKETER_VIEW_ONLY
